import { getUA } from './util/ua'

const ua = getUA()
let BGUrl = './static/images/open_in_safari.35352a1.jpg'
if (ua.isAndroid && ua.isWeibo) {
  BGUrl = './static/images/open_in_android_weibo.jpg'
}
const bgApiPrefix = process.env.NODE_ENV === 'production'? 'https://www.mgtv.com/v':''
const getBgList = () => {
  return fetch(`${bgApiPrefix}/2018/bglist/`)
    .then(function (response) {
      return response.json()
    })
    .then(function (data) {
      if (data && data.background && data.background.list) {
        const list = data.background.list
        if (list.length > 0) {
          return list.map(item => {
            if (ua.isIOS) {
              return item.ios
            } else if (ua.isAndroid) {
              return item.android
            }
            return item.img
          })
        }
      }
      return [BGUrl]
    })
    .catch(function (ex) {
      console.log(ex)
      return [BGUrl]
    })
}

export const getBg = index => {
  return getBgList().then(imgList => {
    if (index === undefined || index > imgList.length - 1) {
      index = 0
    }
    return imgList[index]
  })
}
